import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import InputAdornment from "@mui/material/InputAdornment";
import { Box } from "../../Box/index.js";
import { Icon } from "../../Icon/index.js";
const getIconColor = (disabled, error)=>{
    if (disabled) return 'stroke.secondary';
    if (error) return 'accent.text.error';
    return 'original.brand.primary';
};
const ShowPasswordButton = (t0)=>{
    const $ = c(7);
    const { isShow, disabled, error, onClick } = t0;
    let t1;
    if ($[0] !== disabled || $[1] !== error || $[2] !== isShow) {
        t1 = isShow ? /*#__PURE__*/ jsx(Icon, {
            name: "view",
            size: "24",
            color: getIconColor(disabled, error)
        }) : /*#__PURE__*/ jsx(Icon, {
            name: "hide",
            size: "24",
            color: getIconColor(disabled, error)
        });
        $[0] = disabled;
        $[1] = error;
        $[2] = isShow;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== onClick || $[5] !== t1) {
        t2 = /*#__PURE__*/ jsx(InputAdornment, {
            position: "end",
            children: /*#__PURE__*/ jsx(Box, {
                height: 24,
                onClick: onClick,
                children: t1
            })
        });
        $[4] = onClick;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
export { ShowPasswordButton };
